import { useParams } from "react-router-dom";
import { useProjectsContext } from "../context/ProjectsContext";

export function useProject() {
const {id} = useParams();
const index = parseInt(id, 10);
const {projects, setProjects} = useProjectsContext();
const project = projects[index];

const updateProject=(newProject)=>{
setProjects (prev => {
    const kopia = [...projects];
    kopia[index] = newProject;
    return kopia;
});
};

return {
    project,
    index,
    updateProject
};
}